export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ23.40bb7785.mp3";